export var SortDirection;
(function (SortDirection) {
    SortDirection["up"] = "up";
    SortDirection["down"] = "down";
})(SortDirection || (SortDirection = {}));
//# sourceMappingURL=index.types.js.map